import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  onMessage,
  getToken as getFireBaseToken,
} from 'firebase/messaging';
import { setCookie } from '../utils/cookies';
import COOKIES_STORAGE from './cookiesStorage';

const { COOKIES } = COOKIES_STORAGE;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORE_BUCKET_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const initializeFirebase = () => {
  return initializeApp(firebaseConfig);
};

const messaging = getMessaging(initializeFirebase());

// reqeust permission for registering file to service worker
export const requestPermission = () => {
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register(
          `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
        );
      }
    }
  });
};

// request firebase token
export const getToken = () => {
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
          .then(() => {
            return getFireBaseToken(messaging, {
              vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            })
              .then((currentToken) => {
                if (!currentToken) {
                  // eslint-disable-next-line no-console
                  return console.log(
                    'No registration token available. Request permission to generate one.'
                  );
                }
                setCookie(COOKIES.DEVICE_TOKEN, JSON.stringify(currentToken));
                return Promise.resolve();
              })
              .catch((err) => {
                return err;
              });
          });
      }
    }
  });
};

// on message background listener
export const onMessageListener = () => {
  return new Promise((resolve) => {
    return onMessage(messaging, (payload) => {
      return resolve(payload);
    });
  }).catch((err) => {
    return err;
  });
};
